import { useIntercom } from './useIntercom';

export const useGlobalScriptsAction = () => {
  useIntercom();
};
